import PropTypes from 'prop-types';
import { Display, Text, Stack } from '@/components/ui/index.js';
import styles from './HeroSection.module.css';

/**
 * HeroSection - Landing page hero with gradient headline
 * Features animated gradient text, subtitle, and dual CTAs
 */
export function HeroSection({ onGetStarted, onBrowseEvents }) {
  return (
    <section className={styles.hero}>
      {/* Background gradient overlay */}
      <div className={styles.background}>
        <div className={styles.gradientOrb} />
      </div>

      <div className={styles.content}>
        <Stack direction="column" gap={6} align="center">
          {/* Main headline with gradient animation */}
          <Display
            as="h1"
            size="2xl"
            weight="black"
            align="center"
            gradient
            className={styles.headline}
          >
            Find Your Game
          </Display>

          {/* Subtitle */}
          <Text
            as="p"
            size="lg"
            color="secondary"
            align="center"
            leading="relaxed"
            className={styles.subtitle}
          >
            Connect with local athletes, discover pickup games,
            <br className={styles.break} />
            and find the perfect venue for your sport.
          </Text>

          {/* CTA Buttons */}
          <Stack direction="row" gap={4} className={styles.ctaGroup}>
            <button
              type="button"
              onClick={onGetStarted}
              className={`${styles.button} ${styles.buttonPrimary}`}
            >
              Get Started
            </button>
            <button
              type="button"
              onClick={onBrowseEvents}
              className={`${styles.button} ${styles.buttonSecondary}`}
            >
              Browse Events
            </button>
          </Stack>
        </Stack>
      </div>

      {/* Scroll indicator */}
      <div className={styles.scrollIndicator}>
        <div className={styles.scrollLine} />
      </div>
    </section>
  );
}

HeroSection.propTypes = {
  onGetStarted: PropTypes.func.isRequired,
  onBrowseEvents: PropTypes.func.isRequired,
};

export default HeroSection;
